import React from "react";

const Footer = () => {
  return (
    <p className="footer">
      Copyright © 2020 JarekIT - GitHub:{" "}
      <a href="http://www.github.com/JarekIT">www.github.com/JarekIT</a> -
      Portfolio: <a href="http://www.jarekit.pl">www.JarekIT.pl</a>
      <br />
      Pokemon Fight (JavaScript):{" "}
      <a href="https://pokemon-fight-jarekit.netlify.app/">
        https://pokemon-fight-jarekit.netlify.app/
      </a>
      <br />
      Pokemon Catcher (Angular):{" "}
      <a href="http://pokemon-jarekit.netlify.app">
        https://pokemon-jarekit.netlify.app
      </a>
    </p>
  );
};
export default Footer;
